import { render, staticRenderFns } from "./pie3dType1.vue?vue&type=template&id=15137b23&scoped=true&"
import script from "./pie3dType1.vue?vue&type=script&lang=js&"
export * from "./pie3dType1.vue?vue&type=script&lang=js&"
import style0 from "./pie3dType1.vue?vue&type=style&index=0&id=15137b23&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15137b23",
  null
  
)

export default component.exports